'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var debug = require('debug');

var log = debug('libp2p:secio');
log.error = debug('libp2p:secio:error');

var DuplexPair = require('it-pair/duplex');

var pipe = require('it-pipe');

var lp = require('it-length-prefixed');

var Wrap = require('it-pb-rpc');

var int32BEEncode = lp.int32BEEncode,
    int32BEDecode = lp.int32BEDecode;

var etm = require('../etm');

var crypto = require('./crypto'); // step 3. Finish
// -- send expected message to verify encryption works (send local nonce)


module.exports = /*#__PURE__*/function () {
  var _finish = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, wrapped) {
    var proto, _DuplexPair, _DuplexPair2, secure, user, network, shake, nonceBack;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            log('3. finish - start');
            proto = state.protocols;
            _DuplexPair = DuplexPair(), _DuplexPair2 = _slicedToArray(_DuplexPair, 2), secure = _DuplexPair2[0], user = _DuplexPair2[1];
            network = wrapped.unwrap();
            pipe(secure, // this is FROM the user
            etm.createBoxStream(proto.local.cipher, proto.local.mac), lp.encode({
              lengthEncoder: int32BEEncode
            }), network, // and gets piped INTO and FROM the network
            lp.decode({
              lengthDecoder: int32BEDecode
            }), etm.createUnboxStream(proto.remote.cipher, proto.remote.mac), secure // and gets piped TO the user
            ); // Exchange nonces over the encrypted stream for final verification

            shake = Wrap(user);
            shake.write(state.proposal.in.rand);
            _context.next = 9;
            return shake.read(state.proposal.in.rand.length);

          case 9:
            nonceBack = _context.sent;
            crypto.verifyNonce(state, nonceBack.slice());
            log('3. finish - finish'); // Awesome that's all folks.

            state.secure = shake.unwrap();

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function finish(_x, _x2) {
    return _finish.apply(this, arguments);
  }

  return finish;
}();